import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import AuthContext from "../../context/AuthContext";
import { useHistory } from "react-router-dom";

function QuotationOrder(props) {
  const [message, setMessage] = useState(null);
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [discount, setDiscount] = useState(0);
  const [totalWithDiscount, setTotalWithDiscount] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const history = useHistory();
  const [orderItems, setOrderItems] = useState([]);
  const [freeItemsDiscount, setFreeItemsDiscount] = useState(0);

  // Services that use open-price logic
  const openPriceServices = [
    "Maintenance Fee",
    "Electrical Accessories",
    "Fiber Installation",
    "Labor Fees",
    "IT Support",
    "Fiber Cable",
  ];

  useEffect(() => {
    let isMounted = true;

    const fetchOrderDetails = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/order/details/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              order_id: props.order_id,
            },
          },
        );

        if (response.status === 200 && isMounted) {
          const items = response.data;

          const validatedItems = items.map((item) => {
            const backendTotal = Number(item.total_price) || 0;

            return {
              ...item,
              product_selling:
                item.item_type === "Product"
                  ? Number(item.product_selling) || 0
                  : null,

              service_selling:
                item.item_type === "Service"
                  ? Number(item.service_selling) || 0
                  : null,

              // ✅ ABSOLUTE RULE:
              // if is_free → 0
              // else → backend total_price ONLY
              total_price: item.is_free ? 0 : backendTotal,
            };
          });

          setOrderItems(validatedItems);

          const total = calculateTotal(validatedItems);
          const freeItemsTotal = calculateInitialDiscount(validatedItems);

          setTotalWithoutDiscount(total);
          setFreeItemsDiscount(freeItemsTotal);
          setDiscount(freeItemsTotal);
          setTotalWithDiscount(total - freeItemsTotal);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchOrderDetails();
    return () => (isMounted = false);
  }, [authTokens.access, props.order_id, user.username]);

  const calculateTotal = (items) => {
    return items.reduce(
      (sum, item) => sum + (Number(item.total_price) || 0),
      0,
    );
  };

  const calculateInitialDiscount = (items) => {
    return items.reduce((sum, item) => {
      if (item.is_free) return sum + (Number(item.total_price) || 0);
      return sum;
    }, 0);
  };

  const handleDiscountChange = (value) => {
    const v = Number(value);
    if (!isNaN(v) && v >= 0 && v <= totalWithoutDiscount) {
      setDiscount(v);
      setTotalWithDiscount(totalWithoutDiscount - v);
    }
  };

  const submitData = {
    Action: "Post",
    order: props.order_id,
    total: totalWithoutDiscount,
    discount,
    userdealer: user.username,
    items: orderItems.map((item) => ({
      item_type: item.item_type,
      item_name:
        item.item_type === "Product" ? item.product_name : item.service_name,
      quantity: item.quantity,
      unit_price:
        item.item_type === "Service" &&
        openPriceServices.includes(item.service_name)
          ? item.total_price
          : item.item_type === "Product"
            ? item.product_selling
            : item.service_selling,
      is_free: item.is_free,
    })),
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await Axios.post(`${API_URL}/inventory/quotations/`, submitData, {
        headers: { Authorization: `Bearer ${authTokens.access}` },
      });
      showMessage("Creation successful!", "success");
    } catch (error) {
      console.error(error);
      showMessage("Creation failed!", "danger");
    }
  };

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => history.push("/accounting/quotation"), 1200);
    setTimeout(() => setMessage(null), 1000);
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <table className="table">
            <thead>
              <tr>
                <th>Item Type</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total Price</th>
                <th>Is Free</th>
              </tr>
            </thead>
            <tbody>
              {orderItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.item_type}</td>
                  <td>
                    {item.item_type === "Product"
                      ? item.product_name
                      : item.service_name}
                  </td>
                  <td>{item.quantity}</td>
                  <td>
                    {item.item_type === "Service" &&
                    openPriceServices.includes(item.service_name)
                      ? `$${item.total_price.toFixed(2)}`
                      : item.item_type === "Product"
                        ? `$${item.product_selling.toFixed(2)}`
                        : `$${item.service_selling.toFixed(2)}`}
                  </td>

                  {/* FIXED — backticks were wrong */}
                  <td>{`$${item.total_price.toFixed(2)}`}</td>

                  <td>{item.is_free ? "Yes" : "No"}</td>
                </tr>
              ))}

              <tr>
                <td colSpan="5" className="text-right">
                  Total:
                </td>
                <td>{`$${totalWithoutDiscount.toFixed(2)}`}</td>
              </tr>

              <tr>
                <td colSpan="5" className="text-right">
                  Discount:
                </td>
                <td>
                  <input
                    type="number"
                    min={0}
                    max={totalWithoutDiscount}
                    value={discount}
                    onChange={(e) => handleDiscountChange(e.target.value)}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="5" className="text-right">
                  Total with Discount:
                </td>
                <td>{`$${totalWithDiscount.toFixed(2)}`}</td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="btn btn-primary btn-md">
            Create Quotation
          </button>
        </form>
      </div>

      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            right: "10px",
            margin: "10px",
            zIndex: 9999,
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default QuotationOrder;
